import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import findParentBySelector from './utils';
import s from './TextExpander.scss';

const someText = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
const someText2 = 'Cmentarz greckokatolicki w Kowalówce założony pod koniec XVIII w. (działka↵Kowalówka Nr 1120).'
class TextExpander extends React.Component {
  componentDidMount = () => {
    this.checkTextLength();
    this.setMinMaxText();
  }
  componentDidUpdate() {
    this.checkTextLength();
    this.setMinMaxText();
  }

  setMinMaxText = () => {
    const thisElement = document.getElementById(this.props.expId);
    const minMax = thisElement.nextSibling;
    if (this.props.expId === 'opis') {
      minMax.innerHTML = '+ Pełny opis';
      thisElement.classList.remove('minimized-text');
      return;
    }

    if (this.props.expId === 'opis_pelny') {
      const parentOfOpisPelny = findParentBySelector(thisElement, '.feature-container');
      parentOfOpisPelny.style.display = 'none'; // hides this description;
    }

    if (thisElement.classList.contains('minimized-text')) {
      minMax.innerHTML = '+ Więcej';
    } else {
      minMax.innerHTML = null;
    }
  }
  checkTextLength = () => {
    const thisElement = document.getElementById(this.props.expId);
    const isLongText = thisElement.innerHTML.length > 94;
    if (isLongText) {
      thisElement.className = 'normal-size-text minimized-text';
    } else {
      thisElement.className = 'normal-size-text';
    }
  }

  handleClick = () => {
    const clickedElement = document.getElementById(this.props.expId);
    const minMax = clickedElement.nextSibling;
    if (this.props.expId === 'opis') {
      const parentOfOpis = findParentBySelector(clickedElement, '.feature-container');
      const opisPelny = parentOfOpis.nextSibling.querySelector('#opis_pelny').innerHTML;
      clickedElement.innerHTML === opisPelny ? clickedElement.innerHTML = this.props.expValue : clickedElement.innerHTML = opisPelny;
      minMax.innerHTML === '+ Pełny opis' ? minMax.innerHTML = '- Skrócony opis' : minMax.innerHTML = '+ Pełny opis';
      this.props.checkScroll();
      return;
    }

    clickedElement.classList.toggle('minimized-text');

    if (clickedElement.classList.contains('minimized-text')) {
      minMax.innerHTML = '+ Więcej';
    } else {
      minMax.innerHTML = '- Mniej';
    }
    this.props.checkScroll();
  }

  render() {
    const expId = this.props.expId
    return (
      <div className="exp-container">
        <div
          id={expId}
          ref={m => { this.featureText = m; }}
        >
          {this.props.children}
        </div>
        <div
          className="min-max"
          onClick={this.handleClick}
        >
        mniej / więcej
        </div>
      </div>
    );
  }
}

export default withStyles(s)(TextExpander);



// WEBPACK FOOTER //
// src/components/utils/TextExpander.js